import React from 'react'; // eslint-disable-line
import Tooltip from 'rc-tooltip';
import SmallModal from './SmallModal';
import ValidatedInput from '../../components/forms/ValidatedInput';
import i18n from '../../i18n';
import UserSelectedIconSelect from '../../components/pages/UserSelectedIconSelect';
import constants from '../../constants';

export default class AddEditContentModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { name: props.addEditItem.name, hasMenuItem: props.addEditItem.hasMenuItem, icon: this.props.icon };

        this.setName = this.setName.bind(this);
        this.setChecked = this.setChecked.bind(this);
        this.changeIcon = this.changeIcon.bind(this);
    }

    setName(e) {
        this.setState({ name: e.target.value });
    }

    setChecked(e) {
        this.setState({ hasMenuItem: e.target.checked });
    }

    changeIcon(icon) {
        this.setState({ icon });
    }

    render() {
        const title = this.props.isAdd ? i18n.t('pages.add-page') : i18n.t('pages.edit-page');
        const isValid = this.state.name && this.state.name.length > 0;
        const saveButton = (
            <button id="pages-save" className={`btn-design-system primary ${isValid ? '' : 'disabled'}`} type="button" onClick={() => { this.props.savePage(this.state.name, this.state.hasMenuItem, this.state.isAdd ? null : this.state.icon.value); }}>
                {this.props.isAdd ? i18n.t('add') : i18n.t('save')}
            </button>
        );
        const wrappedSaveButton = isValid
            ? saveButton
            : (
                <Tooltip
                    placement="bottom"
                    trigger="[hover, focus]"
                    mouseEnterDelay={0}
                    mouseLeaveDelay={0.1}
                    overlay={<span data-qa="content-save-validation-message">{i18n.t('pages.add.validation.name-required')}</span>}
                >
                    <span style={{ cursor: 'not-allowed' }}>
                        {saveButton}
                    </span>
                </Tooltip>
            );
        return (
            <SmallModal title={title} visible={this.props.visible} close={this.props.close}>
                <ValidatedInput
                    containerClass="input_Text"
                    labelText={i18n.t('pages.add.page-name')}
                    value={this.state.name}
                    name="name"
                    onChange={(e) => { return this.setName(e); }}
                    errorMessage=""
                    hasError={false}
                    successMessage=""
                    hasSuccess={false}
                    charLimit={12}
                    menuTitle
                />
                <div className="check-rec">
                    <label
                        data-qa="page-has-menu-item"
                        id="page-has-menu-item__label"
                    >
                        <input
                            data-qa="page-has-menu-item-checkbox"
                            id="page-has-menu-item"
                            defaultChecked={this.state.hasMenuItem === true}
                            onChange={(e) => { return this.setChecked(e); }}
                            type="checkbox"
                        />
                        <span className={this.state.hasMenuItem === false ? 'checkbox-rec empty' : 'checkbox-rec checked'} />
                        <span className="page-has-menu-item">
                            {i18n.t('pages.add.has-menu-item')}
                        </span>
                    </label>
                </div>
                {this.props.userSelectedIcons && this.state.hasMenuItem
                && (
                    <div className="navigation-section">
                        <h4>Navigation Icon</h4>
                        {' '}
                        <UserSelectedIconSelect type={2} autoUpdate={false} id={this.state.addEditItem?.Id} icon={this.state.icon?.value?.length > 1 ? this.state.icon : constants.IconList.find((f) => { return f.value === 'file'; })} changeIcon={this.changeIcon} />
                    </div>
                )}
                <div className="pages-save-cancel">
                    {wrappedSaveButton}
                    <button id="pages-cancel" className="btn-design-system secondary" type="button" onClick={this.props.close}>{i18n.t('cancel')}</button>
                </div>
            </SmallModal>
        );
    }
}
